import { GET, POST, Call } from './API';

const PATH_ROOT = 'U002';

export type A01Input = {
  audition_id: string;
  examination_no: number;
  lang: string;
  representative_user?: string;
};
export type A01Output = {
  title: string;
  start_dtm: string;
  end_dtm: string;
  now_dtm: Date;
  domain_txt: string;
  end_custom_txt: string;
  start_txt: string;
  end_txt: string;
  examination_no: number;
  user_detail_flg: string;
  birth: string;
  phone_number: string;
  specific_use_consent: string;
  privacy_policy_consent: string;
  audition_terms_consent: string;
  group_ap: string;
  googletag: string;
  googletag2: string;
};
export async function A01(input: A01Input, cancellation?: AbortSignal): Promise<A01Output> {
  const param = new URLSearchParams();
  param.append('audition_id', input.audition_id);
  param.append('examination_no', input.examination_no.toString());
  param.append('lang', input.lang);
  if (input.representative_user) {
    param.append('representative_user', input.representative_user);
  }
  return await GET(`${PATH_ROOT}/audition?${param.toString()}`, cancellation);
}

export type A02Input = {
  phoneNumber: string;
  path: string;
  term_of_service_consent: string;
  privacy_notice_consent: string;
  specific_use_consent: string;
  birth: Date | null;
  lang: string;
  status?: string;
  session_id?: string;
  recaptcha_token: string;
};
export type A02Output = {
  status: string;
  msgid: string;
};
export async function A02(input: A02Input, cancellation?: AbortSignal): Promise<A02Output> {
  return await POST(`${PATH_ROOT}/temp_account`, {
    phone_number: input.phoneNumber,
    path: input.path,
    term_of_service_consent: input.term_of_service_consent,
    privacy_notice_consent: input.privacy_notice_consent,
    specific_use_consent: input.specific_use_consent,
    birth: input.birth?.toLocaleDateString('ja-JP'),
    lang: input.lang,
    status: input.status,
    session_id: input.session_id,
    recaptcha_token: input.recaptcha_token,
    signal: cancellation,
  });
}

export type A03Input = {
  phoneNumber: string;
  sessionId: string;
};
export type A03Output = {
  status: string;
  exsting_user_flg: string;
  msgid: string;
};
export async function A03(input: A03Input, cancellation?: AbortSignal): Promise<A03Output> {
  return await POST(`${PATH_ROOT}/phone_verification`, {
    phone_number: input.phoneNumber,
    session_id: input.sessionId,
    signal: cancellation,
  });
}

export type A04Input = {
  audition_id: string;
  examination_no: number;
  user_id_a: string;
  lang: string;
};
// 応募フォーム情報
export type ApplyForm = {
  // オーディションID
  audition_id: string;
  // 審査No
  examination_no: number;
  // 応募フォームNo
  apply_form_no: number;
  // 言語区分
  lang: string;
  // ソートNo
  sort_no: number;
  // 必須区分
  required: string;
  // 質問内容
  question: string;
  // 質問フォーマット
  format: string;
  // 質問区分
  q_kbn: string;
  // 選択肢
  choices: string;
  // 選択値
  value: string;
  // スタイルシート
  style: string;
  // プレースホルダー
  place_holder: string;
  // 汎用項目１
  general1: string;
  // 汎用項目２
  general2: string;
  // 汎用項目３
  general3: string;
  // リビジョン
  revision: number;
};
// 都道府県情報
type Prefecture = {
  // 都道府県区分
  sno: string;
  // 都道府県名
  svalue: string;
  // 都道府県名(英語表記)
  svalue3: string;
};
// 希望会場リスト
type PreferredVenue = {
  // オーディションID
  audition_id: string;
  // 審査No
  examination_no: number;
  // 審査日程No
  examination_s_no: number;
  // 審査名
  examination_title: string;
  // 審査会場
  examination_venue: string;
  // 都道府県(区分)
  prefectures: string;
  // 都道府県名
  svalue: string;
  // 都道府県名(英語表記)
  svalue3: string;
  // 会場住所
  address: string;
  // 審査日(審査開始日時より日付のみ取得)
  dtm: string;
  // 希望会場
  preferred_venue: string;
  // 希望会場(英語表記)
  preferred_venue3: string;
};
// 応募者情報
type UserInfo = {
  // 応募者名(姓)
  lastname: string;
  // 応募者名(名)
  firstname: string;
  // 応募者名(姓)カナ
  lastname_kana: string;
  // 応募者名(名)カナ
  firstname_kana: string;
};
export type A04Output = {
  status: string;
  apply_form: ApplyForm[];
  prefectures: Prefecture[];
  preferred_venue_list: PreferredVenue[];
  userinfo: UserInfo[];
};
export async function A04(input: A04Input, cancellation?: AbortSignal): Promise<A04Output> {
  return await POST(
    `${PATH_ROOT}/get_apply_form`,
    {
      audition_id: input.audition_id,
      examination_no: input.examination_no,
      user_id_a: input.user_id_a,
      lang: input.lang,
    },
    false,
    cancellation
  );
}

// 回答リスト
export type Answer = {
  // オーディションID
  audition_id: string;
  // 審査No
  examination_no: number;
  // 応募フォームno
  apply_form_no: number;
  // 応募者ID
  user_id_a: string;
  // 回答内容
  answer: string;
  // 回答内容_補足
  answer_etc: string;
  // 回答区分
  answer_kbn: string | null;
};
// 同意書リスト(国内ドメインのみ)
export type Consent = {
  // 同意ID
  consent_id: number;
  // 同意者
  consenter: string;
  // 同意書種別
  consent_type: string;
  // オーディションID
  audition_id: string;
  // 同意書バージョン 国内向けの場合、どのアンケートで回答したかわかるように審査Noを登録
  consent_version: number;
  // 添付ファイル
  file: string;
  // 管理者承認
  admin_approval: string;
};
export type A05Input = {
  // 回答リスト
  answer_list: Answer[];
  // 同意書リスト(国内ドメインのみ) 質問フォームが同意書の場合のみこちらに格納する。
  consent_list: Consent[];
  // ログインユーザID
  user_id_a: string;
};
export type A05Output = {
  status: string;
  msgid: string;
};
export async function A05(input: A05Input, cancellation?: AbortSignal): Promise<A05Output> {
  const answer_list = input.answer_list.map((answer) => ({
    audition_id: answer.audition_id,
    examination_no: answer.examination_no,
    apply_form_no: answer.apply_form_no,
    user_id_a: answer.user_id_a,
    answer: answer.answer,
    answer_etc: answer.answer_etc,
    answer_kbn: answer.answer_kbn,
  }));
  const body = {
    answer_list: answer_list,
    consent_list: input.consent_list,
    user_id_a: input.user_id_a,
  };
  return await POST(`${PATH_ROOT}/insert_answer`, body, false, cancellation);
}

export type A06Input = {
  // オーディションID
  audition_id: string;
  // 審査No
  examination_no: string;
  // ログインユーザID
  user_id_a: string;
  // アップロードファイル
  file: Blob;
  // ファイル名
  file_name: string;
};
export type A06Output = {
  status: string;
  msgid: string;
  s3uri: string;
};
export async function A06(input: A06Input, cancellation?: AbortSignal): Promise<A06Output> {
  const form = new FormData();
  form.append('audition_id', input.audition_id);
  form.append('examination_no', input.examination_no);
  form.append('user_id_a', input.user_id_a);
  form.append('file', input.file);
  form.append('file_name', input.file_name);

  return await Call(`${PATH_ROOT}/file_upload`, {
    method: 'POST',
    body: form,
    signal: cancellation,
  });
}

export type A07Input =
  | {
      // アップロード区分:応募フォームでのアップロード用
      upload_kbn: '8';
      // オーディションID
      audition_id: string;
      // ログインユーザID
      user_id: string;
      // ファイル名
      file_name: string;
    }
  | {
      // アップロード区分:同意書のアップロード用
      upload_kbn: '9';
      // 同意ID
      consent_id: number;
      // ログインユーザID
      user_id: string;
      // ファイル名
      file_name: string;
    };
export type A07Output = {
  status: string;
  msgid: string;
  // ファイルアップロード用署名付きURL
  url: string;
  // S3ObjectUrlのKey部分
  key: string;
};
export async function A07(input: A07Input, cancellation?: AbortSignal): Promise<A07Output> {
  const body = input;
  return await POST(`${PATH_ROOT}/file_upload_url`, body, false, cancellation);
}

export type A20Input = {
  sessionId: string;
};
export type A20Output = {
  status: string;
  msgid: string;
};
export async function A20(input: A20Input, cancellation?: AbortSignal): Promise<A20Output> {
  const param = new URLSearchParams();
  param.append('session_id', input.sessionId);
  return await GET(`${PATH_ROOT}/phone_verification?${param.toString()}`, cancellation);
}

export type A21Input = {
  user_id: string;
  phone1: string;
  password: string;
  session_id: string;
  lang: string;
  path: string;
  status?: string;
};
export type A21Output = {
  status: string;
  msgid: string;
};
export async function A21(input: A21Input, cancellation?: AbortSignal): Promise<A21Output> {
  return await POST(`${PATH_ROOT}/create_user`, {
    user_id: input.user_id,
    phone1: input.phone1,
    password: input.password,
    session_id: input.session_id,
    lang: input.lang,
    path: input.path,
    signal: cancellation,
  });
}

export type A22Input = {
  user_id: string;
  lastname: string;
  firstname: string;
  lastname_kana: string;
  firstname_kana: string;
  birth: Date | null;
  mail: string;
  parent_name?: string;
  parent_phone?: string;
  audition_id?: string;
};
export type A22Output = {
  status: string;
  msgid: string;
};
export async function A22(input: A22Input, cancellation?: AbortSignal): Promise<A22Output> {
  return await POST(`${PATH_ROOT}/update_user_detail`, {
    user_id: input.user_id,
    firstname: input.firstname,
    lastname: input.lastname,
    firstname_kana: input.firstname_kana,
    lastname_kana: input.lastname_kana,
    birth: input.birth?.toLocaleDateString('ja-JP'),
    mail: input.mail,
    parent_name: input.parent_name ?? '',
    parent_phone: input.parent_phone ?? '',
    audition_id: input.audition_id ?? '',
    signal: cancellation,
  });
}

export type A24Input = {
  mail: string;
  path: string;
  birth: Date | null;
  lang: string;
  auditionId: string;
  representative_user?: string;
  recaptcha_token: string;
};
export type A24Output = {
  status: string;
  msgid: string;
};
export async function A24(input: A24Input, cancellation?: AbortSignal): Promise<A24Output> {
  return await POST(`${PATH_ROOT}/send_consent_form`, {
    mail: input.mail,
    path: input.path,
    birth: input.birth?.toLocaleDateString('ja-JP'),
    lang: input.lang,
    audition_id: input.auditionId,
    representative_user: input.representative_user,
    recaptcha_token: input.recaptcha_token,
    signal: cancellation,
  });
}

export type A25Input = {
  sessionId: string;
  representative_user?: string;
  audition_id: string;
  lang: string;
};
export type A25Output = {
  status: string;
  msgid: string;
  specific_use_file_required: string;
  privacy_policy_file_required: string;
  audition_terms_file_required: string;
};
export async function A25(input: A25Input, cancellation?: AbortSignal): Promise<A25Output> {
  const param = new URLSearchParams();
  param.append('session_id', input.sessionId);
  if (input.representative_user) {
    param.append('representative_user', input.representative_user);
  }
  param.append('audition_id', input.audition_id);
  param.append('lang', input.lang);
  return await GET(`${PATH_ROOT}/validate_session?${param.toString()}`, cancellation);
}

export type A26Input = {
  sessionId: string;
  lang: string;
  audition_id: string;
  representative_user?: string;
  terms_file_name: string;
  privacy_notice_file_name: string;
  specific_use_file_name: string;
  privacy_policy_file_name: string;
  audition_terms_file_name: string;
  evidence_file_name: string;
  name?: string;
  user_id?: string;
};
export type A26Output = {
  terms: {
    url: string;
    key: string;
  };
  privacy_notice: {
    url: string;
    key: string;
  };
  specific_use: {
    url: string;
    key: string;
  };
  privacy_policy: {
    url: string;
    key: string;
  };
  audition_terms: {
    url: string;
    key: string;
  };
  evidence: {
    url: string;
    key: string;
  };
};
export async function A26(input: A26Input, cancellation?: AbortSignal): Promise<A26Output> {
  return await POST(`${PATH_ROOT}/upload_consent_form`, {
    session_id: input.sessionId,
    lang: input.lang,
    audition_id: input.audition_id,
    representative_user: input.representative_user ?? '',
    specific_use_file_name: input.specific_use_file_name,
    terms_file_name: input.terms_file_name,
    privacy_notice_file_name: input.privacy_notice_file_name,
    privacy_policy_file_name: input.privacy_policy_file_name,
    audition_terms_file_name: input.audition_terms_file_name,
    evidence_file_name: input.evidence_file_name,
    name: input.name ?? '',
    user_id: input.user_id ?? '',
    signal: cancellation,
  });
}

export type A27Input = {
  user_id?: string;
  audition_id: string;
  examination_no?: number;
  lang: string;
  consent_type: string;
};
export type A27Output = {
  consent_text: string;
  revision: string;
};
export async function A27(input: A27Input, cancellation?: AbortSignal): Promise<A27Output> {
  const param = new URLSearchParams();
  param.append('audition_id', input.audition_id);
  param.append('examination_no', input.examination_no ? input.examination_no.toString() : '');
  param.append('lang', input.lang);
  param.append('consent_type', input.consent_type);
  if (input.user_id) {
    param.append('user_id', input.user_id);
  }
  return await GET(`${PATH_ROOT}/consent_text?${param.toString()}`, cancellation);
}

export type A28Input = {
  birth: Date | null;
  auditionId: string;
  name: string;
  audition_id: string;
  representative_user: string;
  phone_number: string;
  audition_revision: string;
};
export type A28Output = {
  status: string;
  msgid: string;
};
export async function A28(input: A28Input, cancellation?: AbortSignal): Promise<A28Output> {
  return await POST(`${PATH_ROOT}/create_group_user`, {
    name: input.name,
    birth: input.birth?.toLocaleDateString('ja-JP'),
    phone_number: input.phone_number,
    audition_id: input.auditionId,
    representative_user: input.representative_user,
    audition_revision: input.audition_revision,
    signal: cancellation,
  });
}

export type A29Input = {
  sessionId?: string;
  status?: string;
};
export type A29Output = {
  status: string;
  msgid: string;
};
export async function A29(input: A29Input, cancellation?: AbortSignal): Promise<A29Output> {
  const param = new URLSearchParams();
  if (input.sessionId) {
    param.append('session_id', input.sessionId);
  }
  if (input.status) {
    param.append('status', input.status);
  }
  return await GET(`${PATH_ROOT}/validate_status?${param.toString()}`, cancellation);
}

export type A30Input = {
  audition_id: string;
  user_id: string;
  revision: string;
  consent_type: string;
};
export type A30Output = {
  status: string;
  msgid: string;
};
export async function A30(input: A30Input, cancellation?: AbortSignal): Promise<A30Output> {
  return await POST(`${PATH_ROOT}/consent_register`, {
    user_id: input.user_id,
    audition_id: input.audition_id,
    revision: input.revision,
    consent_type: input.consent_type,
    signal: cancellation,
  });
}

export type A31Input = {
  audition_id: string;
  user_id: string;
  examination_no: number;
};
export type A31Output = {
  status: string;
  msgid: string;
};
export async function A31(input: A31Input, cancellation?: AbortSignal): Promise<A31Output> {
  return await POST(
    `${PATH_ROOT}/get_examination_info`,
    {
      user_id: input.user_id,
      audition_id: input.audition_id,
      examination_no: input.examination_no,
    },
    false,
    cancellation
  );
}

export type A32Input = {
  user_id: string;
};
export type A32Output = {
  status: string;
  msgid: string;
  consent_id: number;
};
/** 同意ID取得 */
export async function A32(input: A32Input, cancellation?: AbortSignal): Promise<A32Output> {
  return await POST(`${PATH_ROOT}/get_consent`, {
    user_id: input.user_id,
    signal: cancellation,
  });
}

export type A33Input = {
  audition_id: string;
  user_id: string;
  group_ap: string;
  member_number: number;
  lang: string;
};
export type A33Output = {
  status: string;
  msgid: string;
  group_registration_path: string;
};
export async function A33(input: A33Input, cancellation?: AbortSignal): Promise<A33Output> {
  return await POST(`${PATH_ROOT}/group_approval`, {
    audition_id: input.audition_id,
    user_id: input.user_id,
    group_ap: input.group_ap,
    member_number: input.member_number,
    lang: input.lang,
    signal: cancellation,
  });
}

export type A34Input = {
  user_id: string;
  post_code: string;
};
export type A34Output = {
  status: string;
  msgid: string;
  post_list: {
    post_code: string;
    prefectures_kana: string;
    city_kana: string;
    town_area_kana: string;
    prefectures_kbn: string;
    prefectures: string;
    city: string;
    town_area: string;
  }[];
};
export async function A34(input: A34Input, cancellation?: AbortSignal): Promise<A34Output> {
  return await POST(
    `${PATH_ROOT}/get_address`,
    {
      user_id: input.user_id,
      post_code: input.post_code,
    },
    false,
    cancellation
  );
}
